
import { apiSlice } from "./apiSlice";
import { ENGLISHQUESTION_URL } from "../constants";

export const englishQuestionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createEnglishQuestion: builder.mutation({
      query: (data) => ({
        url: ENGLISHQUESTION_URL,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["EnglishQuestion"],
    }),

    updateEnglishQuestion: builder.mutation({
      query: ({ questionId, ...data }) => ({
        url: `${ENGLISHQUESTION_URL}/${questionId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { questionId }) => [
        "EnglishQuestion",
        {
          type: "EnglishQuestion",
          id: questionId,
        },
      ],
    }),

    deleteEnglishQuestion: builder.mutation({
      query: (questionId) => ({
        url: `${ENGLISHQUESTION_URL}/${questionId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["EnglishQuestion"],
    }),

    getEnglishQuestionsByChapter: builder.query({
      query: (chapterId) => ({
        url: `${ENGLISHQUESTION_URL}/chapter/${chapterId}`,
      }),
      providesTags: (result, error, chapterId) => [
        {
          type: "EnglishQuestion",
          id: `CHAPTER-${chapterId}`,
        },
      ],
      keepUnusedDataFor: 5,
    }),

    getEnglishQuestionsByGroup: builder.query({
      query: (groupId) => ({
        url: `${ENGLISHQUESTION_URL}/group/${groupId}`,
      }),
      providesTags: (result, error, groupId) => [
        {
          type: "EnglishQuestion",
          id: `GROUP-${groupId}`,
        },
        {
          type: "EnglishQuestionGroup",
          id: groupId,
        },
      ],
      keepUnusedDataFor: 5,
    }),

    getEnglishQuestionsBySubject: builder.query({
      query: (subjectId) => ({
        url: `${ENGLISHQUESTION_URL}/subject/${subjectId}`,
      }),
      providesTags: (result, error, subjectId) => [
        {
          type: "EnglishQuestion",
          id: `SUBJECT-${subjectId}`,
        },
      ],
      keepUnusedDataFor: 5,
    }),

    getEnglishQuestionById: builder.query({
      query: (questionId) => ({
        url: `${ENGLISHQUESTION_URL}/${questionId}`,
      }),
      providesTags: (result, error, questionId) => [
        {
          type: "EnglishQuestion",
          id: questionId,
        },
      ],
      keepUnusedDataFor: 5,
    }),

    getEnglishQuestionAvailability: builder.query({
      query: ({ chapter, difficulty, questionType, group }) => ({
        url: `${ENGLISHQUESTION_URL}/availability`,
        params: {
          chapter,
          difficulty,
          questionType,
          group,
        },
      }),
      keepUnusedDataFor: 5,
    }),

    getEnglishQuestionStatistics: builder.query({
      query: ({ subject, chapter } = {}) => ({
        url: `${ENGLISHQUESTION_URL}/statistics`,
        params: {
          subject,
          chapter,
        },
      }),
      keepUnusedDataFor: 5,
    }),

    recalculateEnglishQuestionGroup: builder.mutation({
      query: (groupId) => ({
        url: `${ENGLISHQUESTION_URL}/group/${groupId}/recalculate`,
        method: "POST",
      }),
      invalidatesTags: (result, error, groupId) => [
        "EnglishQuestion",
        {
          type: "EnglishQuestion",
          id: `GROUP-${groupId}`,
        },
        {
          type: "EnglishQuestionGroup",
          id: groupId,
        },
      ],
    }),

    toggleEnglishQuestionStatus: builder.mutation({
      query: (questionId) => ({
        url: `${ENGLISHQUESTION_URL}/${questionId}/status`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, questionId) => [
        "EnglishQuestion",
        {
          type: "EnglishQuestion",
          id: questionId,
        },
      ],
    }),
   getEnglishGroupAvailability: builder.query({
  query: ({ chapter }) => ({
    url: `${ENGLISHQUESTION_URL}/group-availability`,
    params: {
      chapter,
    },
  }),
}),
  }),
});

export const {
  useCreateEnglishQuestionMutation,
  useUpdateEnglishQuestionMutation,
  useDeleteEnglishQuestionMutation,
  useGetEnglishQuestionsByChapterQuery,
  useGetEnglishQuestionsByGroupQuery,
  useGetEnglishQuestionsBySubjectQuery,
  useGetEnglishQuestionByIdQuery,
  useGetEnglishQuestionAvailabilityQuery,
  useGetEnglishQuestionStatisticsQuery,
  useRecalculateEnglishQuestionGroupMutation,
  useToggleEnglishQuestionStatusMutation,
  useGetEnglishGroupAvailabilityQuery,
  useLazyGetEnglishGroupAvailabilityQuery, // ADD THIS
} = englishQuestionApiSlice;

